import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.subgrupos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Subgrupo ha sido creado con éxito."}
                title={"Nuevo Subgrupo"}
                buttonTitle={"Nuevo Subgrupo"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
                buttonClass={this.props.buttonClass}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Abreviatura</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="abreviatura"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="mail"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Grupo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker
                            fieldName={"padre_id"}
                            url={api.usuarios.grupos.select}
                            onChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })}
                            value={this.state.padre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Create.js